export const SERVICE_OWNER = 'service-owner';
export const SERVICE_ADMIN = 'service-admin';
export const SERVICE_AUDITOR = 'service-auditor';
export const ORG_OWNER = 'org-owner';
export const ORG_ADMIN = 'org-shipping-admin';
export const ORG_AUDITOR = 'org-auditor';
export const ORG_RESELLER = 'org-reseller';
export const ORG_DISTRIBUTOR = 'org-distributor';
export const ROLE_NONE = 'role-none';
export const CUSTOMER = 'Customer';

export const CustomerAndServiceRoles = [
  SERVICE_OWNER,
  SERVICE_ADMIN,
  SERVICE_AUDITOR,
  ORG_OWNER,
  ORG_ADMIN,
  ORG_AUDITOR,
];

export const serviceOrgRoles = [SERVICE_OWNER, SERVICE_ADMIN, SERVICE_AUDITOR];

export const serviceOrgRolesWithoutAuditor = [SERVICE_OWNER, SERVICE_ADMIN];

export const deliveryOrgRolesOld = [ORG_OWNER, ORG_ADMIN, ORG_AUDITOR];

export const deliveryOrgRoles = [ROLE_NONE, ORG_OWNER, ORG_ADMIN, ORG_AUDITOR];

export const deliveryOrgDistributorView = [ROLE_NONE, ORG_DISTRIBUTOR];

export const deliveryOrgResellerView = [ROLE_NONE, ORG_RESELLER];

export const allECRoles = [ORG_OWNER, ORG_ADMIN, ORG_AUDITOR, ORG_DISTRIBUTOR, ORG_RESELLER];
export const allCustomerRoles = [ORG_OWNER, ORG_ADMIN, ORG_AUDITOR];
